module.exports = __webpack_public_path__ + "medical-and-health.ee9c250b569c43180bc6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.ttf
// module chunks = styles